<template>
  <div class="transaction-detail">
    <ul class="sum-foot">
      <li>
        <span class="name">总箱数：</span>
        <span class="value">1</span>
      </li>
      <li>
        <span class="name">总体积(cm³)：</span>
        <span class="value">132480</span>
      </li>
      <li>
        <span class="name">总体积重(kg)：</span>
        <span class="value">22.08</span>
      </li>
      <li>
        <span class="name">总实重(kg)：</span>
        <span class="value">28</span>
      </li>
      <li>
        <span class="name">总计费重(kg)：</span>
        <span class="value">28</span>
      </li>
      <li>
        <span class="name">SKU品类数量：</span>
        <span class="value">8</span>
      </li>
      <li class="default">
        <span class="name">整货最小重量(kg)：</span>
        <span class="value">100</span>
      </li>
      <li class="default">
        <span class="name">体积重计算比率：</span>
        <span class="value">6000</span>
      </li>
      <li>
        <a class="toggle-icon" href="#" @click.prevent="showDetailsTable = !showDetailsTable">
          <span v-if="!showDetailsTable"><i class="el-icon-arrow-right"></i>查看详情</span>
          <span v-if="showDetailsTable"><i class="el-icon-arrow-down"></i>收起列表</span>
        </a>
      </li>
    </ul>
    <el-collapse-transition>
      <el-table :data="detailsData"  style="width: 100%" v-if="showDetailsTable">
        <el-table-column prop="length" label="长(cm)"></el-table-column>
        <el-table-column prop="width" label="宽(cm)"></el-table-column>
        <el-table-column prop="height" label="高(cm)"></el-table-column>
        <el-table-column prop="volume" label="体积(cm³)"></el-table-column>
        <el-table-column prop="volumeWeight" label="体积重(kg)"></el-table-column>
        <el-table-column prop="actualWeight" label="实重(kg)"></el-table-column>
        <el-table-column prop="billedWeight" label="计费实重(kg)"></el-table-column>
      </el-table>
    </el-collapse-transition>
  </div>
</template>

<script>
export default {
  data () {
    return {
      showDetailsTable: false,
      transactionDetailsDialog: false,
      detailsData: [
        {length: '46', width: '48', height: '60', radio: '6000', volume: '132480', volumeWeight: '22.08', actualWeight: '28', billedWeight: '28'}
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.sum-foot{
  width: 100%;
  >li{
    display: inline-block;
    width: 33%;
    margin-bottom: 15px;
    .name, .value{
      font-weight: 700;
    }
    &.default{
      color: #99a9bf;
    }
  }
}
.toggle-icon{
  color: #409eff;
  i{
    margin-right: 5px;
  }
  &:hover{
    text-decoration: underline;
  }
}
</style>





// WEBPACK FOOTER //
// src/views/transactionDetail/detail.vue